// Generated by ts-to-zod
import { z } from 'zod'

import { APP_EVENT, KNOWN_EVENT_SENDERS } from './../../../types/next/enums'
import { iActionSchema } from './actions.zod'
import { uncastObjectSchema } from './common.zod'
import { designTokensSchema } from './design.zod'
import { appEventSchema, knownEventSendersSchema } from './enums.zod'
import { featureFlagsSchema } from './flags.zod'
import { stepIdSchema } from './ids.zod'

export const iAppEventSchema = iActionSchema.extend({
  type: appEventSchema,
  from: knownEventSendersSchema
})

export const previewListenerReadyEventSchema = iAppEventSchema.extend({
  type: z.literal(APP_EVENT.PREVIEW_LISTENER_READY),
  from: z.literal(KNOWN_EVENT_SENDERS.JOURNEY_APP),
  payload: z.never().optional()
})

const pureJourneyV3Schema = z.any()

export const previewUpdateEventSchema = iAppEventSchema.extend({
  type: z.literal(APP_EVENT.PREVIEW_UPDATE),
  from: z.union([
    z.literal(KNOWN_EVENT_SENDERS.BUILDER_APP),
    z.literal(KNOWN_EVENT_SENDERS.DESIGN_BUILDER_APP)
  ]),
  payload: z.object({
    token: z.string().optional(),
    selectedStepId: stepIdSchema.optional(),
    journey: z.union([pureJourneyV3Schema, uncastObjectSchema, z.undefined()]),
    featureFlags: featureFlagsSchema.optional()
  })
})

export const previewThemeUpdateEventSchema = z.object({
  type: z.literal(APP_EVENT.PREVIEW_THEME_UPDATE),
  from: z.literal(KNOWN_EVENT_SENDERS.DESIGN_BUILDER_APP),
  payload: z.object({
    theme: uncastObjectSchema.optional(),
    designTokens: designTokensSchema.optional(),
    logoUrl: z.string().optional()
  })
})

export const appEventsSchema = z.union([
  previewListenerReadyEventSchema,
  previewUpdateEventSchema,
  previewThemeUpdateEventSchema
])
